import * as React from 'react';
import Button from '../../../../common/components/Button';
import {GLOBAL, PAY_WARRANTY_MX} from '../../../constants/LabelConstants';
import AssetsManager from '../../../../common/utils/AssetsManager';
import {PayWarrantySuccessProps} from '../../../types/mx/components';

class PayWarrantySuccessView extends React.Component<PayWarrantySuccessProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {amount, cardNumber} = this.props;
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container">
                            <div className="row d-flex justify-content-center mb-5 mt-3">
                                <img src={AssetsManager('/assets/images/common/payment-success-icon.svg')}/>
                            </div>
                            <div className="row p-none d-flex justify-content-center mb-3">
                                <h2 className="title-step">{PAY_WARRANTY_MX.PAYMENR_SUCCESS}</h2>
                            </div>
                            <div className="row p-none d-flex justify-content-center pb-6 border-bottom">
                                {`Realizamos un recargo de ${amount} en tu tarjeta Visa terminada en ${cardNumber}.`}
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-center">
                                    <Button text={GLOBAL.ACCEPT} onPress={() => this.props.onPressNext()}
                                            role="button"
                                            customClass="px-md-5" type="outlined"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PayWarrantySuccessView;
